export const FILTERS_SET = 'FILTERS_SET'
export const FILTERS_RESET = 'FILTERS_RESET'
export const FILTERS_INIT_DATA = 'FILTERS_INIT_DATA'
export const FILTERS_ORDER = 'FILTERS_ORDER'
export const FILTERS_REMOVE_ITEMS = 'FILTERS_REMOVE_ITEMS'
export const FILTERS_SERVICE_SET = 'FILTERS_SERVICE_SET'
